export default __webpack_public_path__ + "static/media/red_tel.aaa0d473.png";